import React, {useState} from 'react';
import {IonButton, IonCard, IonCardContent, IonCardHeader, IonIcon,
  IonCardTitle, IonCardSubtitle} from "@ionic/react";
import {createOutline, trashOutline} from "ionicons/icons";
import AplicacaoEventoEdit from "./AplicacaoEventoEdit";

interface AplicacaoEventoProps {
  categoria: any;
  produtos: any[];
  setCategoria: (categoria: any[]) => void;
  removeCategoria: (categoriaId: number) => void;
}

const AplicacaoEvento: React.FC<AplicacaoEventoProps> = (props) => {
  const {categoria} = props;
  const [editMode, setEditMode] = useState(false);

  const setProdutos = (produtos: any[]) => {
    props.setCategoria({
      ...props.categoria,
      produtos,
    });
  };

  return (
    <>
      <IonCard>
        <IonCardHeader>
          <IonCardSubtitle>
            Categoria
          </IonCardSubtitle>
          <IonCardTitle>
            {categoria.nome}
          </IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          {
            editMode ?
              <AplicacaoEventoEdit
                produtos={props.produtos}
                selecionados={categoria.produtos}
                setProdutos={setProdutos}
                setCloseEdit={() => setEditMode(false)}
              /> :
              <>
                {
                  categoria.produtos.map((p: any) => (
                    <div key={p.id}>
                      {p.nome}
                    </div>
                  ))
                }
                <div className="flex justify-end">
                  <IonButton
                    size={'small'}
                    fill={'clear'}
                    onClick={() => setEditMode(true)}
                    color={'medium'}
                  >
                    <IonIcon icon={createOutline} slot="icon-only"/>
                  </IonButton>
                  <IonButton
                    size={'small'}
                    fill={'clear'}
                    onClick={() => props.removeCategoria(categoria.id)}
                    color={'medium'}
                  >
                    <IonIcon icon={trashOutline} slot="icon-only"/>
                  </IonButton>
                </div>
              </>
          }
        </IonCardContent>
      </IonCard>
    </>
  );
}

export default AplicacaoEvento;
